import { useCallback, useSyncExternalStore } from 'react';
import {
    CrosshairInteractionMode,
    ToolManager,
} from '~/engine/tool/ToolManager';
import { PlaneView } from '~/engine/view/views/PlaneView';

/**
 * Subscribes to ToolManager state changes and returns the current
 * {@link CrosshairInteractionMode} for the given view.
 *
 * Uses useSyncExternalStore for automatic deduplication —
 * the component only re-renders when the mode actually changes.
 */
export function useCrosshairInteraction(
    view: PlaneView | null
): CrosshairInteractionMode {
    const subscribe = useCallback((onStoreChange: () => void) => {
        const emitter = ToolManager.getEventEmitter();
        emitter.on('toolStateChanged', onStoreChange);
        return () => {
            emitter.off('toolStateChanged', onStoreChange);
        };
    }, []);

    return useSyncExternalStore(subscribe, () =>
        ToolManager.getCrosshairInteractionMode(view)
    );
}
